import moment from "moment";
import React from "react";
import { useNavigate, useParams } from "react-router";
import { TicketDto } from "src/store/ticket/type";
import { TicketStatusContainer } from "./ticketStatus";

const TicketListCard = ({
  ticket,
  selected,
}: {
  ticket: TicketDto;
  selected: boolean;
}) => {
  const navigate = useNavigate();
  const { tab } = useParams<{ tab: string }>();
  return (
    <React.Fragment>
      <div
        onClick={() => navigate("/ticket/" + tab + "?ticketId=" + ticket.Id)}
        className={
          "ticketListCard" + (selected ? " ticketListCardSelected" : "")
        }
      >
        <div className="ticketListCardInnerContainer">
          <div className="ticketCode">
            {ticket.Code}
            <div className="ticketTypeName">{ticket.TicketType}</div>
          </div>
          <div className="ticketTextContainer">
            <div className="ticketFirstGrid">
              <div className="ticketName">{ticket.ClientClientName}</div>
              <div className="ticketDate">
                {moment(ticket.CreateTime).fromNow()}
              </div>
            </div>
            <div className="ticketFirstGrid">
              <div className="ticketSubject">{ticket.Subject}</div>
              <div className="ticketDate">
                {TicketStatusContainer(
                  ticket.TicketStatusTypeId,
                  ticket.TicketStatusType
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TicketListCard;
